import { logger as LOG } from '@garnish/logger';

// ─── Logger ──────────────────────────────────────────────────────────────────

export const orderingMachineLogger = LOG.extend('Ordering');

LOG.disable('Ordering');
